module.exports = __webpack_public_path__ + "static/media/TP_Icon_HotColdEyeMask.91dee929.png";